import React from 'react';
import './ButtonGroup.css';

export type ButtonGroupOrientation = 'horizontal' | 'vertical';

export interface ButtonGroupProps {
	orientation?: ButtonGroupOrientation;
	gap?: string;
	className?: string;
	children: React.ReactNode;
}

export const ButtonGroup: React.FC<ButtonGroupProps> = ({
	orientation = 'horizontal',
	gap,
	className = '',
	children,
}) => {
	const style: React.CSSProperties = gap ? { gap } : {};

	return (
		<div
			className={`button-group button-group-${orientation} ${className}`.trim()}
			style={style}
		>
			{children}
		</div>
	);
};
